import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import Loader from "../common/Loader";
import { getTaskData, uploadTask } from "../../../service/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";

const TaskList = () => {
  const { applicationId } = useParams();
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalOne, setShowModalOne] = useState(false);
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(null);
  const [inputMode, setInputMode] = useState("hours");
  const [btnloading, setBtnLoading] = useState(false);

  const fetchTasks = async () => {
    try {
      const data = await getTaskData(applicationId);
      setTaskData(data?.data || []);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setShowModalOne(true);
  };

  useEffect(() => {
    fetchTasks();
  }, [applicationId]);

  const handleProgressChange = (e) => {
    setProgress(Number(e.target.value));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUploadTask = async (e) => {
    e.preventDefault();

    // if (!file) {
    //   toast.error("Please select a file.");
    //   return;
    // }

    const formData = new FormData(e.target);
    formData.append("jobApplicationId", applicationId);
    formData.append("progressPercent", progress);
    formData.append("file", file);

    try {
      setBtnLoading(true);
      const response = await uploadTask(formData);
      toast.success(response.data.message || "Task uploaded successfully!");

      // ✅ UPDATE TABLE AFTER UPLOAD
      await fetchTasks();

      // ✅ CLEAR FORM & CLOSE MODAL
      setShowModalOne(false);
      setFile(null);
      setProgress(0);
      e.target.reset();
    } catch (error) {
      console.error("Error uploading task:", error);
      toast.error(error.response?.data?.message || "Failed to upload task.");
    } finally {
      setBtnLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="titlSectionu userpaneltitle text-left position-relative d-flex justify-content-space-between mb-4">
          <h2>Task List</h2>
          <button
            className="mainbtn"
            onClick={handleOpenModal}
            style={{ backgroundColor: "#270b79", border: "1px solid #270b79" }}
          >
            Upload Task
          </button>
        </div>

        {taskData.length === 0 ? (
          <div className="alert alert-info text-center">No task found.</div>
        ) : (
          <table className="table mt-4 hj-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Description</th>
                <th>Hours Worked</th>
                <th>Progress</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {taskData.map((task, index) => (
                <tr key={task.id || index}>
                  <td>{index + 1}</td>
                  <td>{task.title}</td>
                  <td>
                    {task.description?.length > 70
                      ? task.description.substring(0, 70) + "..."
                      : task.description}
                  </td>
                  <td>{task.hoursWorked}</td>
                  <td>{task.progressPercent}%</td>
                  <td>
                    <span
                      style={{
                        backgroundColor:
                          task.employerApprovedTask === "Approved"
                            ? "#00e721"
                            : task.employerApprovedTask === "Rejected"
                            ? "#e71b00"
                            : task.employerApprovedTask === "Modified"
                            ? "#00a9e7"
                            : "#e7b100",
                        padding: "2px 12px",
                        borderRadius: "15px",
                        color: "#fff",
                      }}
                    >
                      {task.employerApprovedTask || "Pending"}
                    </span>
                  </td>
                  <td>
                    <button
                      className="mainbtn"
                      onClick={() => {
                        setSelectedTask(task);
                        setShowModal(true);
                      }}
                    >
                      View Task
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* VIEW MODAL */}
        {showModal && selectedTask && (
          <div
            className="modal show fade"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5>Task Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>
                    <strong>Title:</strong> {selectedTask.title}
                  </p>
                  <p>
                    <strong>Remarks:</strong> {selectedTask.description}
                  </p>
                  <p>
                    <strong>Hours Worked:</strong> {selectedTask.hoursWorked}
                  </p>
                  <p>
                    <strong>Progress:</strong> {selectedTask.progressPercent}%
                  </p>
                  <p>
                    <strong>Status:</strong>
                    <span
                      style={{
                        backgroundColor:
                          selectedTask.employerApprovedTask === "Approved"
                            ? "#00e721"
                            : selectedTask.employerApprovedTask === "Rejected"
                            ? "#e71b00"
                            : selectedTask.employerApprovedTask === "Modified"
                            ? "#00a9e7"
                            : "#e7b100",
                        padding: "2px 12px",
                        borderRadius: "15px",
                        color: "#fff",
                      }}
                    >
                      {selectedTask.employerApprovedTask || "Pending"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* UPLOAD MODAL */}
        {showModalOne && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Task</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModalOne(false)}
                  ></button>
                </div>

                <div className="modal-body hj-form">
                  <form onSubmit={handleUploadTask}>
                    <div className="mb-2">
                      <label>Title *</label>
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="mb-2">
                      <label>Remarks *</label>
                      <textarea
                        name="description"
                        className="form-control"
                        rows={4}
                        required
                      />
                    </div>

                    {/* HOURS */}
                    <div className="work-input-section">
                      {/* Toggle Buttons */}
                      <div className="mb-3">
                        <label className="me-3">Choose Input Method:</label>
                        <div className="btn-group">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              inputMode === "hours"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setInputMode("hours")}
                          >
                            Enter Hours
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              inputMode === "time"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setInputMode("time")}
                          >
                            Enter Start & End Time
                          </button>
                        </div>
                      </div>

                      {/* Hours Worked */}
                      {inputMode === "hours" && (
                        <div className="row mb-2">
                          <div className="col-md-12">
                            <label>Hours Worked *</label>
                            <input
                              type="number"
                              name="hoursWorked"
                              className="form-control"
                              placeholder="Enter total working hours"
                              required={inputMode === "hours"}
                            />
                          </div>
                        </div>
                      )}

                      {/* Start & End Time */}
                      {inputMode === "time" && (
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <label>Start Time *</label>
                            <input
                              type="time"
                              name="startTime"
                              className="form-control"
                              required={inputMode === "time"}
                            />
                          </div>
                          <div className="col-md-6">
                            <label>End Time *</label>
                            <input
                              type="time"
                              name="endTime"
                              className="form-control"
                              required={inputMode === "time"}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>Progress *</label>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        step="1"
                        value={progress}
                        onChange={handleProgressChange}
                        className="form-range"
                      />
                      <div className="d-flex justify-content-between">
                        <small>0%</small>
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              progress < 40
                                ? "red"
                                : progress < 70
                                ? "orange"
                                : "green",
                          }}
                        >
                          {progress}%
                        </span>
                        <small>100%</small>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label>Attach File *</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={handleFileChange}
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-100 normalbtn"
                      disabled={btnloading}
                    >
                      {btnloading ? (
                        <span>
                          <i className="fa fa-spinner fa-spin"></i> Uploading...
                        </span>
                      ) : (
                        "Upload Task"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default TaskList;
